export default __webpack_public_path__ + "static/media/new-message-icon.5f9f4c9b.svg";